export default __webpack_public_path__ + "static/media/gameplay-icon-10.e9463c11.gif";